import { computed } from 'vue';
import useClock from './useClock';
import useRooms from './useRooms';
import useTranslations from '@/compositions/useTranslations';
// eslint-disable-next-line max-lines-per-function
const useMySchedule = (group, teamId) => {
    const { nowDate, now } = useClock();
    const { roomNameFromId } = useRooms();
    const remainingTime = computed(() => {
        if (group.value === null || group.value.start_time === null)
            return 0;
        return group.value.start_time - now.value + group.value.duration;
    });
    const currentRoomId = computed(() => {
        if (!group.value)
            return null;
        return group.value.getRoomId(teamId.value, nowDate.value);
    });
    const currentRoomName = computed(() => {
        if (currentRoomId.value === null) {
            return 'KokiBar';
        }
        else if (currentRoomId.value === 'pause') {
            return useTranslations().translation('kokibarPause');
        }
        else if (remainingTime.value < 10 * 60) {
            return '';
        }
        else {
            return roomNameFromId(currentRoomId.value);
        }
    });
    return {
        currentRoomId,
        currentRoomName,
        remainingTime
    };
};
export default useMySchedule;
